/* eslint-disable indent */
/* eslint-disable multiline-ternary */
import React, { useEffect, useRef, useState } from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import MyImage from '@shared/components/myImage'
import NoData from '@shared/components/noData'
import useWindowSize from '@shared/hooks/windowSize'
import noDataImg from '@assets/images/hil/hilNodata.svg'
import CommonNav from '@shared/components/commonNav'
import { useRouter } from 'next/router'

function HILMatches({ fixtureData = [] }) {
  const [filter, setFilter] = useState('Men')
  const [isUpcoming, setIsUpcoming] = useState(true)
  const router = useRouter()
  const { query } = router
  const [finalData, setFinalData] = useState([])
  const [dataToMap, setDataToMap] = useState([])
  const [width] = useWindowSize()
  const [isViewMore, setIsViewMore] = useState(false)
  const matchContainerRef = useRef(null)

  const formatCurrentDate = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  function scrollToMatch() {
    const formattedDate = formatCurrentDate()

    setTimeout(() => {
      const element = document.getElementById(formattedDate)
      if (element && matchContainerRef.current) {
        matchContainerRef.current.scrollTo({
          top: element.offsetTop - 450,
          behavior: 'smooth'
        })
      }
    }, 0)
  }

  useEffect(() => {
    scrollToMatch()
  }, [filter])

  useEffect(() => {
    if (query.tab === 'result') {
      setIsUpcoming(false)
    } else {
      setIsUpcoming(true)
    }
  }, [query.tab])

  const sortData = fixtureData.sort((a, b) => new Date(a?.date) - new Date(b?.date)) || []

  function getNewData(data) {
    const newData = []
    for (let i = 0; i < data.length; i++) {
      const someData = newData.find(item => item.date === data[i].date)

      if (someData) {
        someData.matches.push(data[i])
      } else {
        const a = { date: data[i].date, showDate: data[i].showDate, matches: [data[i]] }
        newData.push(a)
      }
    }
    return newData
  }

  useEffect(() => {
    if (sortData?.length > 0) {
      setIsViewMore(false)
      const d = getNewData(sortData)
      setFinalData(d)
      handleChange('Men', d)
    }
  }, [sortData])

  function handleChange(value, data) {
    setFilter(value)
    matchContainerRef.current.scrollTo(0, 0)

    const d =
      value === 'Men'
        ? data
            ?.map(d => ({
              ...d,
              matches: d?.matches?.filter(match => match?.gender === 'male')
            }))
            .filter(d => d?.matches?.length > 0)
        : finalData
            ?.map(d => ({ ...d, matches: d?.matches?.filter(match => match?.gender === 'female') }))
            .filter(d => d?.matches?.length > 0)

    setDataToMap(d)
  }

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const upComingMatches = dataToMap?.filter(d => {
    const matchDate = new Date(d?.date)
    matchDate.setHours(0, 0, 0, 0)
    return matchDate >= today
  })

  const pastMatches = dataToMap?.filter(d => {
    const matchDate = new Date(d?.date)
    matchDate.setHours(0, 0, 0, 0)
    return matchDate < today
  })

  const data =
    width > 767
      ? dataToMap
      : isUpcoming
      ? isViewMore
        ? upComingMatches
        : upComingMatches?.slice(0, 5)
      : isViewMore
      ? pastMatches
      : pastMatches?.slice(0, 5)
  return (
    <div className={styles.matchContainer}>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="my-0">Matches</h3>
        <div className={styles.filterContainer}>
          <button
            className={`${styles.filterButton} ${filter === 'Men' ? styles.activeFilter : ''}`}
            onClick={() => handleChange('Men', finalData)}>
            Men
          </button>
          <button
            className={`${styles.filterButton} ${filter === 'Women' ? styles.activeFilter : ''}`}
            onClick={() => handleChange('Women', finalData)}>
            Women
          </button>
        </div>
      </div>
      {width < 767 && (
        <CommonNav
          items={[
            { navItem: 'Upcoming', url: '/hockey-india-league?tab=upcoming', active: isUpcoming },
            { navItem: 'Result', url: '/hockey-india-league?tab=result', active: !isUpcoming }
          ]}
          isMatch
        />
      )}
      <div className={`${styles.matches}`} ref={matchContainerRef}>
        {data?.length === 0 && (
          <div>
            <NoData img={noDataImg} title={'Quiet Turf Today!'} />
            <p className="text-center">No games scheduled right now, but stay excited—action is on the way!</p>
          </div>
        )}
        {data?.length > 0 &&
          data?.map((m, index) => {
            if (m?.matches?.length > 0) {
              return (
                <React.Fragment key={index}>
                  <h6 className={styles.date}>{m?.showDate}</h6>
                  {m?.matches?.map((item, index) => {
                    return (
                      <div key={index} id={item?.date} className={`${styles.match} d-flex justify-content-between align-items-center`}>
                        <div className="d-flex flex-column align-items-center text-center w-100">
                          <MyImage src={item?.t1Logo} height={54} width={54} />
                          <h6 className="my-0 mt-1">{item?.t1Name}</h6>
                        </div>
                        <div className="text-center w-100">
                          <p className={styles.phase}>{item?.stageName}</p>
                          {item?.team1Score !== null && item?.team2Score !== null ? (
                            <div className="d-flex justify-content-center align-items-center">
                              {item?.team1PenaltyScore > 0 && <span className="text-secondary mx-1">{`(${item?.team1PenaltyScore})`}</span>}
                              <h3 className="my-1 font-bold">{`${item?.team1Score} - ${item?.team2Score}`}</h3>
                              {item?.team2PenaltyScore > 0 && <span className="text-secondary mx-1">{`(${item?.team2PenaltyScore})`}</span>}
                            </div>
                          ) : (
                            <h6 className="my-1">{item?.showTime}</h6>
                          )}

                          <p className="text-secondary mt-2">{item?.venue}</p>
                        </div>
                        <div className="d-flex flex-column align-items-center text-center w-100">
                          <MyImage src={item?.t2Logo} height={54} width={54} />
                          <h6 className="my-0 mt-1">{item?.t2Name}</h6>
                        </div>
                      </div>
                    )
                  })}
                </React.Fragment>
              )
            } else return null
          })}
        {width < 767 && !isViewMore && (
          <div className="w-100 d-flex mb-2 justify-content-center">
            <button className="theme-btn btn btn-primary" onClick={() => setIsViewMore(true)}>
              View More
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

HILMatches.propTypes = {
  fixtureData: PropTypes.array
}

export default HILMatches
